.root {
  flex: 1;
  min-width: 0;
  padding: 3rem 4rem;
}

.error {
  max-width: 45em;
  color: brown;
}

.error > p {
  margin: 0 0 1rem;
}

.error > p:first-child {
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.detailedError {
  color: brown;
}

.detailedError > summary {
  max-width: 45em;
  margin-bottom: 1.5rem;
  font-weight: bold;
  cursor: pointer;
}

.detailedError > pre {
  margin: -0.5rem 0 1.5rem;
  padding-bottom: 0.75rem;
  font-size: 90%;
  scrollbar-width: thin;
  overflow-x: auto;
  overflow-y: visible;
}

.btn {
  display: inline-flex;
  margin-right: 0.75rem;
  padding: 0.25rem 0.75rem;
  background-color: rgba(165, 42, 42, 0.1);
  border: 2px solid rgb(165, 42, 42);
  border-radius: 0.25rem;
  color: inherit;
  font-size: 90%;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.btn:hover {
  background-color: brown;
  color: white;
}

.debug {
  margin-top: 3rem;
  font-size: 90%;
}

.debug > summary {
  cursor: pointer;
}

.debug > ul {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.hint {
  font-style: italic;
  margin-left: 1.5rem;
  margin-top: 0;
}
